var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F0ECFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7232 14.7589C32.6613 14.4462 33.5538 15.3387 33.2411 16.2768L28.1845 31.4467C27.8561 32.4318 26.5163 32.5631 26.0029 31.6603L22.9078 26.2172C22.6409 25.7478 22.2522 25.3591 21.7828 25.0922L16.3397 21.9971C15.437 21.4838 15.5682 20.1439 16.5534 19.8155L31.7232 14.7589Z",
    stroke: "#6054B8",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7856 23.2148L22.7856 25.2148",
    stroke: "#6054B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestContact);
export default __webpack_public_path__ + "static/media/request-contact.9166e47b1be61f3dfbfd70e728b356ff.svg";
export { ForwardRef as ReactComponent };